import React from 'react'
import QS from 'qs'
import { MultiMenuTrigger } from 'react-multi-menu'
import { useHistory } from 'react-router-dom'
import Icon, { IconButton } from '../../Shared/Icon'

import styles from './ActionMenu.module.css'

export const showActionModal = (value, opts) => {
  let { history, record, recordIds, baseURL } = opts

  if (recordIds && !record && recordIds.length === 1) {
    record = { __pk: recordIds[0] }
    recordIds = null
  }

  if (value === 'create') {
    return history.push('/actions/new')
  }

  const { action, input } = value

  const query = QS.stringify({
    data: {
      [input.id]: recordIds || record.__pk,
    },
  })

  history.replace(`${baseURL}/actions/${action.id}?${query}`)
}

export default function ActionMenu({
  record,
  recordIds,
  view,
  actions,
  baseURL,
}) {
  const history = useHistory()

  const handleSelect = value => {
    return showActionModal(value, { history, record, recordIds, baseURL })
  }

  const menu = actions.concat([
    {
      label: (
        <span className={styles.menuRow}>
          <Icon icon="add" className={styles.rowIcon} />
          New Action
        </span>
      ),
      value: 'create',
    },
  ])

  return (
    <MultiMenuTrigger
      width={300}
      menu={menu}
      onSelect={handleSelect}
      rowHeight={40}
    >
      <IconButton color="grey" icon="overflow" />
    </MultiMenuTrigger>
  )
}
